import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, path = "", noindex = false }) => {
  const baseUrl = "https://bekids.shop";
  const fullUrl = `${baseUrl}${path}`;
  const siteName = "BE KIDS";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
